console.log('GG wheel running');
(function(){
  const root = document.querySelector('[data-gg-wheel]');
  if(!root) return;

  const overlay = root.querySelector('.gg-wheel__overlay');
  const overlayImg = root.querySelector('.gg-wheel__overlayImg');
  const wedges = Array.from(root.querySelectorAll('.gg-wedge'));

  // Apply background images
  wedges.forEach(w => {
    const img = w.getAttribute('data-img');
    if (img) w.style.backgroundImage = `url("${img}")`;
  });

  const activate = (w) => {
    const img = w.getAttribute('data-img');
    const href = w.getAttribute('href') || '#';
    if(!img) return;

    overlayImg.src = img;
    overlay.href = href;
    root.classList.add('is-hovering');
  };

  const deactivate = () => root.classList.remove('is-hovering');

  wedges.forEach(w => {
    w.addEventListener('mouseenter', () => activate(w));
    w.addEventListener('focus', () => activate(w));
  });

  root.addEventListener('mouseleave', deactivate);

  // Mobile: first tap previews, second tap follows link
  wedges.forEach(w => {
    w.addEventListener('touchstart', (e) => {
      if (!root.classList.contains('is-hovering')) {
        activate(w);
        e.preventDefault();
      }
    }, { passive: false });
  });
})();
